const copyWithTextarea = (value: string) => {
  const container = document.activeElement?.closest('[role="dialog"]') ?? document.body;
  const el = document.createElement('textarea');
  el.value = value;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.opacity = '0';
  container.appendChild(el);
  el.select();
  document.execCommand('copy');
  container.removeChild(el);
};

export const copyToClipboard = (value: string): Promise<void> => {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(value).catch(() => copyWithTextarea(value));
  }
  copyWithTextarea(value);
  return Promise.resolve();
};
